var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app",attrs:{"id":"app"}},[_c('div',{staticClass:"app__content",on:{"scroll":_vm.scroll}},[_c('router-view')],1),_c('div',{staticClass:"app__build"},[_c('c-build-version')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }